import { ELEMENT_TYPES, SWITCH_CLASS, TOGGLE_CLASS } from '../constants/tracking';

/**
 * element: an html element
 * Returns the type of element that was interacted with
 **/
const getElementType = (element: HTMLElement): string => {
    if (
        element?.nodeName.toLowerCase() === ELEMENT_TYPES.BUTTON ||
        element?.role === ELEMENT_TYPES.BUTTON
    ) {
        const dataset = element?.dataset;
        const useLink = !!dataset?.useLink;
        return useLink ? ELEMENT_TYPES.LINK : ELEMENT_TYPES.BUTTON;
    }

    // Check for toggle classes
    if (TOGGLE_CLASS.some((toggleClass) => element?.className.includes(toggleClass))) {
        return ELEMENT_TYPES.TOGGLE;
    }

    // Check for switch classes
    if (SWITCH_CLASS.some((switchClass) => element?.className.includes(switchClass))) {
        return ELEMENT_TYPES.SWITCH;
    }

    return ELEMENT_TYPES.LINK;
};

export { getElementType };
